import { Button } from "@/components/ui/button";
import { CollapsibleTrigger } from "@/components/ui/collapsible";
import { RotateCcw, ChevronDown, ChevronUp } from "lucide-react";
import FilterBadge from "./FilterBadge";

interface FilterHeaderProps {
  isOpen: boolean;
  activeFilterCount: number;
  selectedEmiMonth?: string | null;
  onEmiMonthChange?: (month: string) => void;
  emiMonthOptions?: string[];
  onClearAllFilters: () => void;
  hasAnyFilters?: boolean;
}

const FilterHeader = ({
  isOpen,
  activeFilterCount,
  onClearAllFilters,
  hasAnyFilters = false,
}: FilterHeaderProps) => {
  return (
    <div className="p-4 border-b">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0 flex-wrap">
          <CollapsibleTrigger asChild>
            <Button variant="ghost" size="sm" className="gap-2 shrink-0">
              {isOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
              <span className="font-medium">Filters</span>
              <FilterBadge count={activeFilterCount} />
            </Button>
          </CollapsibleTrigger>
        </div>

        <Button
          variant="outline"
          size="sm"
          onClick={onClearAllFilters}
          className="gap-2 shrink-0"
          disabled={!hasAnyFilters}
        >
          <RotateCcw className="h-4 w-4" />
          Clear All
        </Button>
      </div>
    </div>
  );
};

export default FilterHeader;
